import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  padding-bottom: 40px;
`;

export const Content = styled.div`
  width: 760px;
  margin: 20px 20px 0;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #888888;
`;

export const Title = styled.strong`
  padding: 4px;
  border-bottom: 1px solid #888888;
`;

export const LogoImg = styled.img`
  width: 160px;
  margin: 16px 4px;
`;

export const Description = styled.p`
  padding: 4px;
  margin: 4px;
  border: 1px solid #888888;
`;

export const SectionWrapper = styled.div`
  margin: 24px 4px 4px;
  padding: 16px 4px 4px;
  border: 1px solid #888888;

  span.title {
    position: absolute;
    margin-top: -32px;
    background-color: #ffffff;
    padding: 4px;
  }

  div.row {
    display: flex;
    margin-top: -1px;
    padding-left: 1px;
  }

  span.field {
    padding: 4px;
    border: 1px solid #888888;
    margin-left: -1px;
    white-space: nowrap;

    &.blank {
      min-width: 80px;
    }

    &.fullWidth {
      width: 100%;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border: 1px solid #888888;
  border-spacing: 0;
  border-collapse: collapse;

  thead {
    background-color: #cccccc;
    border-bottom: 1px solid #888888;
  }

  tbody {
    background-color: #eeeeee;

    td {
      height: 32px;
    }
  }

  td {
    padding: 2px 4px;
    border-left: 1px solid #888888;
  }
`;
